/**
 * Created by Christof Sander on 18.11.2016.
 */

const utils = require('../lib/utils')

/**
 * this is the user object used on the server to handle user dependent data.
 *
 * @param   storage                object - storage
 * @constructor
 */
function User(storage){
	this.data = storage.session.user;
}

/**
 * this function is used to reset a user
 */
User.prototype.reset = function(){
	var userFlagKey;
	for (userFlagKey in this.data) {
		if(
			userFlagKey != 'serviceDomain'
			&&
			userFlagKey != 'environment'
			&&
			userFlagKey != 'visibleStatus'
			&&
			userFlagKey != 'langCode'
		){
			delete this.data[userFlagKey];
		}
	}
};

/**
 * this function is used to update the users' data by the given data param.
 *
 * @param   data        object - user data which should be updated
 */
User.prototype.update = function(data){
	// reset privileges if necessary
	if(data.privileges) this.data.privileges = {};
	if(data.roleConfigs) this.data.roleConfigs = {};

	utils.refMerge(this.data, data);
};

/**
 * returns if the actual user has the given privilege or not.
 *
 * @param   privilege       string - privilege (can be comma-sperated list) (can contain a suffix - @<scopeName>)
 * @param   scopeName   	string - scopeName
 * @returns boolean
 */
User.prototype.hasAccessTo = function(privilege, scopeName){
	if(!privilege || privilege === null) return true;
	if(!this.data.privileges) return false;

	var self = this;
	var result = true;
	var privilegeParts, scopeNameInCharge, isBlackListPrivilege, hasPrivilege;
	utils.forEach(privilege.split(','), function(privilege){
		privilegeParts = privilege.split('@');
		if(privilegeParts.length > 1){
			scopeNameInCharge 	= privilegeParts[1];
			privilege 			= privilegeParts[0];
		}
		else {
			scopeNameInCharge = scopeName;
		}

		if(
			!(
				result = (
					result
					&&
					Boolean(self.data.privileges[scopeNameInCharge])
					&&
					(
						// allow empty privileges for all users
						!Boolean(privilege)
						||
						(
							(
								// user has access to given privilege ...
								(hasPrivilege = !!self.data.privileges[scopeNameInCharge][privilege])
								&&
								// ... or this is a blacklist privilege
								!(isBlackListPrivilege = (privilege.split(':') || []).indexOf('attributes') > -1)
							)
							||
							(
								!hasPrivilege
								&&
								isBlackListPrivilege
							)
						)
					)
				)
			)
		){
			return false;
		}
	});

	return result;
};

/**
 * returns if the actual user has the given privilege or not.
 *
 * @param   scopeName   	string - scopeName
 * @param   privilegeBase   string - privilege base of privilege path
 * @param   crudType		string - create | read | update | delete (default: read)
 * @param   attributeName   string - name of attribute
 * @returns boolean
 */
User.prototype.hasAttributeAccessTo = function(scopeName, privilegeBase, crudType, attributeName){
	if(!privilegeBase || privilegeBase === null || !attributeName || attributeName === null || !scopeName || scopeName === null) return true;
	if(!this.data.privileges || !this.data.privileges[scopeName] || !this.data.privileges[scopeName][privilegeBase]) return false;
	crudType = (crudType || 'read').toLowerCase();


	if(
		(!this.data.privileges[scopeName][privilegeBase + ':' + crudType] && crudType !== 'show')
		||
		// NOTE: respect black-list system
		this.data.privileges[scopeName][privilegeBase + ':' + crudType + ':attributes:' + attributeName]
	){
		return false;
	}

	return true;
};

/**
 * check if user has access to a given document.
 * document may be optional
 *
 * @see MARK: SEND_MD_DOCS
 *
 * @param [document=null]		string - document to check access for
 * @returns {boolean}
 */
User.prototype.hasAccessToDocs = function(document = null){
	const isAuthenticated = !!((this.data || {}).states || {}).authenticated
	const {
		authenticatedOnly= true,
		scopeRole: {
			scope,
			option,
		} = {}
	} = ((appConfig.docs || {}).byDocument || {})[document || '~MISSING_DOCUMENT~'] || appConfig.docs || {}

	if((authenticatedOnly || scope || option) && !isAuthenticated){
		return false
	}
	if(scope && !option && !this.hasRoleInScope(scope)){
		return false
	}
	if(scope && option && !this.hasRoleOption(option, scope)){
		return false
	}

	return true
};

/**
 * this function works similar to the hasAccessTo method but proofs
 * if the actual user has a specific role option (identified by roleOptionCode) according to the given scope.
 * NOTE: this may be used for miscellaneous options like show the id of an element within a tree.
 *
 * @param	roleOptionCode		string - roleOptionCode
 * @param 	scope				string - optional - scope within the roleOptionCode should be available
 * @return 	boolean - does the actual user has set the roleOption or not?
 */
User.prototype.hasRoleOption = function(roleOptionCode, scope){
	if(!roleOptionCode){
		return true;
	}
	if(
		!scope ||
		!this.data.rolesConfigs ||
		!this.data.rolesConfigs[scope] ||
		!this.data.rolesConfigs[scope].options ||
		!this.data.rolesConfigs[scope].options[roleOptionCode]
	){
		return false;
	}

	return true;
};

/**
 * @param 	scope				string - scope within the user has to have a role
 * @return 	boolean - does the actual user have a role within the given scope or not?
 */
User.prototype.hasRoleInScope = function(scope){
	if(((this.data.rolesConfigs || {})[String(scope || '~~~MISSING_SCOPE~~~')] || {}).scopeRoleID){
		return true
	}

	return false
};

/**
 * @param	roleOptionCode		string - roleOptionCode
 * @param 	scope				string - optional - scope within the roleOptionCode should be available
 * @return 	mixed - roleOptionValue
 */
User.prototype.getRoleOption = function(roleOptionCode, scope){
	if(!roleOptionCode){
		return false;
	}
	if(
		!scope ||
		!this.data.rolesConfigs ||
		!this.data.rolesConfigs[scope] ||
		!this.data.rolesConfigs[scope].options ||
		!this.data.rolesConfigs[scope].options[roleOptionCode]
	){
		return false;
	}

	return this.data.rolesConfigs[scope].options[roleOptionCode];
};

/**
 * returns if the actual user is allowed to see the given status.
 *
 * @param   status      string - status
 * @returns boolean
 */
User.prototype.statusVisible = function(status){
	return (!status || status === null || (this.data.visibleStatus && this.data.visibleStatus[status]));
};

/**
 * this function returns false if it is not possible to serve html from caches (does not have impact on client code)
 * @returns {boolean}
 */
User.prototype.cacheUsageGranted = function(){
	return true;
}

/**
 * this function returns false if it is not possible to serve resources from caches according to the given cacheScope.
 * @param cacheScope		string - cacheScope to check
 * @returns {boolean}
 */
User.prototype.cacheUsageGrantedByCacheScope = function(cacheScope = ''){
	return true;
}

/**
 * this function returns the reference timestamp when the user has been initiated.
 *
 * @returns int - unix timestamp
 */
User.prototype.getReferenceTS = function(){
	return (this.data.states || {}).referenceTimestamp;
};

module.exports = User;